import { message } from "antd";
import api from "@/api";
import store from "@/stores";
import dataJson from "@/../public/data.json";


const { app_detail } = dataJson;

const cryptoJs = require("crypto-js");
type keys = "y+" | "M+" | "d+" | "H+" | "m+" | "s+" | "W+";
type Dukey = {
  [key in keys]: number;
};

export const format = (date: Date, fmt: string) => {
  let ret;
  const o: Dukey = {
    "y+": date.getFullYear(),
    "M+": date.getMonth() + 1,
    "d+": date.getDate(),
    "H+": date.getHours(),
    "m+": date.getMinutes(),
    "s+": date.getSeconds(),
    "W+": date.getDay(),
  };
  // 类型断言
  (Object.keys(o) as (keyof Dukey)[]).forEach((key) => {
    ret = new RegExp("(" + key + ")").exec(fmt);
    if (ret) {
      let str = o[key].toString();
      const len = ret[1].length;
      if (len !== 1 && len > str.length) {
        str = addZero(str, len - str.length);
      }
      fmt = fmt.replace(ret[1], str);
    }
  });
  return fmt;
};

export const addZero = (str: string, len: number) => {
  return `${new Array(len).fill(0).join("")}${str}`;
};

export const getImageBase64 = (imgUrl: string) => {
  return new Promise((resolve, reject) => {
    window.URL = window.URL || window.webkitURL;
    const xhr = new XMLHttpRequest();
    xhr.open("get", imgUrl, true);
    xhr.responseType = "blob";
    xhr.onload = function () {
      if (this.status === 200) {
        //得到一个blob对象
        const blob = this.response;
        // console.log("blob", blob);
        // 至关重要
        const oFileReader = new FileReader();
        oFileReader.onloadend = function (e: any) {
          // 此处拿到的已经是base64的图片了,可以赋值做相应的处理
          // console.log(e.target.result);
          resolve(e.target.result);
        };
        oFileReader.readAsDataURL(blob);
      }
    };
    xhr.send();
  });
};

export const sliceTopic = (topic: string) => {
  const reportIndex = topic.indexOf("/message/property/report");
  topic = topic.slice(0, reportIndex);
  const lastIndex = topic.lastIndexOf("/") + 1;
  topic = topic.slice(lastIndex);

  const typeIndex = topic.lastIndexOf("_") + 1;
  const typeStr = topic.slice(0, typeIndex);
  const serialNumber = parseInt(topic.slice(typeIndex));
  return {
    topic,
    typeStr,
    serialNumber,
  };
};

// 设置元素全屏
export const setFullScreen = (eleId: string) => {
  const video: any = document.getElementById(eleId);
  if (!video) return;
  if (video.requestFullscreen) {
    video.requestFullscreen();
  } else if (video.msRequestFullscreen) {
    video.msRequestFullscreen();
  } else if (video.mozRequestFullScreen) {
    video.mozRequestFullScreen();
  } else if (video.webkitRequestFullscreen) {
    video.webkitRequestFullscreen();
  }
};

const easeInOutQuad = (t: number, b: number, c: number, d: number) => {
  t /= d / 2;
  if (t < 1) {
    return (c / 2) * t * t + b;
  }
  t--;
  return (-c / 2) * (t * (t - 2) - 1) + b;
};

// requestAnimationFrame for Smart Animating http://goo.gl/sx5sts
const requestAnimFrame = (function () {
  return (
    window.requestAnimationFrame ||
    (window as any).webkitRequestAnimationFrame ||
    (window as any).mozRequestAnimationFrame ||
    function (callback) {
      window.setTimeout(callback, 1000 / 60);
    }
  );
})();
export const scrollTo = (dom: any, to: number, duration = 300, callback?: any) => {
  const start = dom.scrollTop;
  const change = to - start;
  const increment = 20;
  let currentTime = 0;
  duration = typeof duration === "undefined" ? 500 : duration;
  const animateScroll = function () {
    // increment the time
    currentTime += increment;
    // find the value with the quadratic in-out easing function
    const val = easeInOutQuad(currentTime, start, change, duration);
    // move the document.body
    dom.scrollTop = val;
    // do the animation unless its over
    if (currentTime < duration) {
      requestAnimFrame(animateScroll);
    } else {
      if (callback && typeof callback === "function") {
        // the animation is done so lets callback
        callback();
      }
    }
  };
  animateScroll();
};

/*
 * 参数 data
 * domId 禁止滚动的容器
 */
export const disableScroll = (domId: string) => {
  const scrollTopVal = document.documentElement.scrollTop || document.body.scrollTop;
  // 禁止滑动
  const selectId = domId || "app";
  const selectDom = document.getElementById(selectId);
  if (selectDom && selectDom.style.position !== "fixed") {
    selectDom.style.position = "fixed";
    selectDom.style.top = "-" + scrollTopVal + "px";
    selectDom.style.width = "100%";
    selectDom.style.overflow = "hidden";
  }
};

export const enableScroll = (domId: string) => {
  /** *取消滑动限制***/
  const selectId = domId || "app";
  const selectDom = document.getElementById(selectId);
  if (selectDom && selectDom.style.position === "fixed") {
    const scrollVal = Math.abs(parseFloat(selectDom.style.top));
    selectDom.style.position = "";
    selectDom.style.overflow = "";
    selectDom.style.top = "";
    if (document.body) {
      document.body.scrollTop = scrollVal;
    }
    if (document.documentElement) {
      document.documentElement.scrollTop = scrollVal;
    }
  }
};

export const hmacSHA256 = (str: string, key: string) => {
  const strVal = cryptoJs.enc.Utf8.parse(str);
  const hmac = cryptoJs.HmacSHA256(key, strVal).toString().toUpperCase();
  return hmac;
};

export const changeSize = (num: number) => {
  const limit = Number(num)
  let size = "";
  if (limit < 0.1 * 1024) {
    //小于0.1KB，则转化成B
    size = limit.toFixed(2) + "B";
  } else if (limit < 0.1 * 1024 * 1024) {
    //小于0.1MB，则转化成KB
    size = (limit / 1024).toFixed(2) + "KB";
  } else if (limit < 0.1 * 1024 * 1024 * 1024) {
    //小于0.1GB，则转化成MB
    size = (limit / (1024 * 1024)).toFixed(2) + "MB";
  } else {
    //其他转化成GB
    size = (limit / (1024 * 1024 * 1024)).toFixed(2) + "GB";
  }

  const sizeStr = size + ""; //转成字符串
  const index = sizeStr.indexOf("."); //获取小数点处的索引
  const dou = sizeStr.substr(index + 1, 2); //获取小数点后两位的值
  if (dou == "00") {
    //判断后两位是否为00，如果是则删除00
    return sizeStr.substring(0, index) + sizeStr.substr(index + 3, 2);
  }
  return size;
};

// 递归查找某个对象 {数组、查找对象得关键字、根据哪个属性查找、子数组的属性名}
export const findDeep = (array: any[], key: any, attr = "value", child = "children") => {
  for (let index = 0; index < array?.length; index++) {
    const element = array[index];

    if (element[attr] === key) {
      return element;
    } else if (element[child]?.length) {
      const item = findDeep(element[child], key, attr, child);

      if (item !== null) {
        return element; // 如果在子路由中找到了目标路由，则返回该路由对象
      }
    }
  }
  return null;
};

// 获取上架审核应用详情
export const getReleaseDetail = async (
  type: string | number | undefined,
  id: string | number | undefined,
  cb?: any
) => {
  const typeObj: any = app_detail.type_obj;
  const typeItem = typeObj[type!];

  try {
    const res: any = await api[typeItem.detailApi]({ id });
    store.dispatch({
      type: "setReleaseDetail",
      payload: res.data,
    });
    if (cb) {
      cb();
    }
  } catch (errorInfo: any) {
    store.dispatch({
      type: "setReleaseDetail",
      payload: null,
    });
    window.message.error(errorInfo?.response?.data?.msg || "请求出错");
  }
};

// js判断两个数组内容是否相等
export const arraysAreEqual = (arr1:any[], arr2:any[]) => {
  if (arr1.length !== arr2.length) {
    return false;
  }
 
  for (let i = 0; i < arr1.length; i++) {
    if (arr1[i] !== arr2[i]) {
      return false;
    }
  }
 
  return true;
}

const unAuthArr=['/questionsDetail'];

/**
 * 校验是否是文档跳转
 * @param routeName 
 * @returns 
 */
export const checkIsDocs=(routeName:string)=>{
    console.log('checkIsDocs',routeName);
    
    return unAuthArr.some((item)=>routeName.includes(item)) || (routeName.includes('/kaihong-developer-documents')&&routeName.includes('.html'));
}

/**
 * 将富文本标签 替换成纯文本
 * @param html 
 * @returns 
 */
export const getPlainText=(html:string)=>{
  const temp = document.createElement('div');
  temp.innerHTML = html;
  return temp.textContent || temp.innerText || "";
}

/** 生成唯一值 id */
export const uniqueId = () => {
  return `${new Date().getTime().toString(36)}${Math.random()
    .toString(36)
    .slice(2, 9)}`;
};

/** 打开新的浏览器页面 */
export const openNewPage = (item: ReferenceDocumentItem | string) => {
  const itemUrl = typeof item === "string" ? item : item.url;
  if (!itemUrl) return;
  const state = store.getState();
  window.open(itemUrl, "_blank");
}